module.exports = __webpack_public_path__ + "static/media/ruler-combined.1f4166b8.svg";